module.exports = __webpack_public_path__ + "img/ChSimplified-T600.ee3bfa42.gif";